import type { WhatsappGroupsTranslations } from '../interfaces/whatsappGroups';

export const whatsappGroupsTranslations: WhatsappGroupsTranslations = {
  page_title: 'Grupos de WhatsApp',
  page_subtitle:
    'Crea grupos en el número de {{brand}}, comparte el enlace de invitación y asigna un agente de IA a cada grupo (máx. 8 participantes).',
  new_group: 'Nuevo grupo',
  search_placeholder: 'Buscar por nombre…',
  empty_title: 'Aún no tienes grupos',
  empty_description:
    'Crea tu primer grupo de WhatsApp y comparte su enlace de invitación.',
  members_badge: '{{count}}/8 miembros',
  suspended_badge: 'Suspendido',
  agent_badge_active: 'Agente activo',
  agent_badge_paused: 'Agente en pausa',
  agent_badge_none: 'Sin agente',
  row_copy_link: 'Copiar enlace',
  row_view: 'Ver grupo',
  row_delete: 'Eliminar',
  delete_confirm_title: 'Eliminar grupo',
  delete_confirm_description:
    'El grupo se eliminará en WhatsApp para todos sus miembros. Esta acción no se puede deshacer.',
  delete_confirm_cta: 'Eliminar',
  link_copied: 'Enlace copiado al portapapeles',
  no_invite_link: 'Sin enlace de invitación',

  create_title: 'Nuevo grupo',
  create_subtitle:
    'El grupo se crea en el número verificado de {{brand}}. Los miembros entran con el enlace de invitación.',
  form_subject_label: 'Nombre del grupo',
  form_subject_placeholder: 'p. ej. Clientes VIP',
  form_subject_required: 'El nombre es obligatorio',
  form_subject_too_long: 'Máximo 128 caracteres',
  form_description_label: 'Descripción',
  form_description_placeholder: 'Descripción opcional del grupo…',
  form_description_too_long: 'Máximo 2048 caracteres',
  form_approval_label: 'Ingreso al grupo',
  approval_required_label: 'Requiere aprobación',
  approval_required_description:
    'Cada solicitud de ingreso debe aprobarse manualmente.',
  auto_approve_label: 'Ingreso automático',
  auto_approve_description:
    'Quien tenga el enlace entra directo (hasta llenar el cupo).',
  form_agent_label: 'Agente de IA (opcional)',
  form_agent_placeholder: 'Selecciona un agente…',
  form_agent_none: 'Sin agente',
  create_submit: 'Crear grupo',
  create_success: 'Grupo creado correctamente',

  back_to_list: 'Volver a grupos',
  suspended_banner:
    'Meta suspendió este grupo. El agente no responderá y no se pueden hacer cambios hasta que se levante la suspensión.',
  tab_members: 'Miembros',
  tab_requests: 'Solicitudes',
  tab_agent: 'Agente',
  tab_settings: 'Ajustes',

  invite_title: 'Enlace de invitación',
  invite_description:
    'Compártelo con las personas que quieres en el grupo. Solo se puede entrar con este enlace.',
  invite_copy: 'Copiar',
  invite_reset: 'Generar nuevo enlace',
  invite_reset_confirm_title: '¿Generar un nuevo enlace?',
  invite_reset_confirm_description:
    'El enlace actual dejará de funcionar. Tendrás que compartir el nuevo.',

  members_title: 'Miembros del grupo',
  members_empty: 'Todavía no hay miembros. Comparte el enlace de invitación.',
  member_remove: 'Expulsar',
  member_remove_confirm_title: 'Expulsar del grupo',
  member_remove_confirm_description:
    'Esta persona saldrá del grupo. Podrá volver a entrar si tiene el enlace vigente.',
  member_joined_at: 'Entró el {{date}}',

  requests_title: 'Solicitudes de ingreso',
  requests_empty: 'No hay solicitudes pendientes.',
  request_approve: 'Aprobar',
  request_reject: 'Rechazar',
  request_status_pending: 'Pendiente',
  request_status_approved: 'Aprobada',
  request_status_rejected: 'Rechazada',
  request_status_revoked: 'Retirada',

  agent_title: 'Agente de IA',
  agent_description:
    'El agente asignado responde automáticamente a los mensajes de este grupo.',
  agent_select_placeholder: 'Selecciona un agente…',
  agent_save: 'Guardar',
  agent_pause: 'Pausar',
  agent_resume: 'Reanudar',
  agent_unbind: 'Quitar agente',
  agent_unbind_confirm_title: 'Quitar el agente del grupo',
  agent_unbind_confirm_description:
    'El agente dejará de responder en este grupo. Puedes asignar otro cuando quieras.',
  agent_none_hint: 'Este grupo no tiene agente asignado.',

  settings_title: 'Ajustes del grupo',
  settings_save: 'Guardar cambios',
  settings_delete_title: 'Eliminar grupo',
  settings_delete_description:
    'Elimina el grupo en WhatsApp para todos sus miembros.',

  cancel: 'Cancelar',
  confirm: 'Confirmar',
  saved: 'Cambios guardados',
  error_generic: 'Algo salió mal. Inténtalo de nuevo.',
};
